import { UserService } from './../base-services/user.service';
import { RefreshType } from './refresh-type';
import { ModalSize } from './modal-size';
import { ListData } from './list-data';
export class ModelData {

    constructor(private userService: UserService){}

    MainList: ListData;
    //DetailList: ListData[];
    MainTitle: string;
    UpdateComponent: any;
    ModalSize: ModalSize;
    RefreshType: RefreshType;
    LoadOnInit: boolean;
    BreadcrumbLabel: string;

    LoadModelData(data): this{
        if(data){
            //let modelData: ModelData = new ModelData();
            this.MainList = new ListData(this.userService).LoadListData(data.mainList);
            //this.DetailList = [];
            //if(data.detailList)
                //data.detailList.forEach(detailList => {
                //this.DetailList.push(new ListData().LoadListData(detailList));
                //})
            this.MainTitle = data.mainTitle;
            this.UpdateComponent = data.updateComponent;
            this.ModalSize = data.modalSize;
            this.RefreshType = data.refreshType;
            this.LoadOnInit = data.loadOnInit;
            this.BreadcrumbLabel = data.breadcrumbLabel != null ? data.breadcrumbLabel : 'NONE';
        }
        return this;
    }
}
